export const SHARE_METHOD_ID_NATIVE = 'native'
export const SHARE_METHOD_ID_CLIPBOARD = 'copy'
export const SHARE_METHOD_ID_EMAIL = 'email'
export const SHARE_METHOD_ID_FACEBOOK = 'facebook'
export const SHARE_METHOD_ID_TWITTER = 'twitter'
export const SHARE_METHOD_ID_WHATSAPP = 'whatsapp'
export const SHARE_METHOD_ID_CHATGPT = 'chatgpt'
export const SHARE_METHOD_ID_PERPLEXITY = 'perplexity'

export const SHARE_METHODS = {
  EMAIL: 'email',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  WHATSAPP: 'whatsapp',
  CHATGPT: 'chatgpt',
  PERPLEXITY: 'perplexity'
}

export const SHARE_METHODS_HIT_INFORMATION = {
  [SHARE_METHOD_ID_EMAIL]: 'Mail',
  [SHARE_METHOD_ID_FACEBOOK]: 'Facebook',
  [SHARE_METHOD_ID_TWITTER]: 'Twitter',
  [SHARE_METHOD_ID_WHATSAPP]: 'Whatsapp',
  [SHARE_METHOD_ID_CLIPBOARD]: 'Copy to Pasteboard',
  [SHARE_METHOD_ID_NATIVE]: 'others',
  [SHARE_METHOD_ID_CHATGPT]: 'ChatGPT',
  [SHARE_METHOD_ID_PERPLEXITY]: 'Perplexity'
}

export const SHARE_METHOD_PLACEHOLDER_APP_NAME = '%{appName}'
export const SHARE_METHOD_PLACEHOLDER_REFERER = '%{referer}'
export const SHARE_METHOD_PLACEHOLDER_TEXT = '%{text}'
export const SHARE_METHOD_PLACEHOLDER_AI_PROMPT = '%{prompt}'
export const SHARE_PLACEHOLDERS_MAP = {
  appName: SHARE_METHOD_PLACEHOLDER_APP_NAME,
  referer: SHARE_METHOD_PLACEHOLDER_REFERER,
  text: SHARE_METHOD_PLACEHOLDER_TEXT,
  prompt: SHARE_METHOD_PLACEHOLDER_AI_PROMPT
}

export const SHARE_METHODS_BASE_URLS = {
  [SHARE_METHODS.FACEBOOK]: `https://www.facebook.com/sharer/sharer.php?u=${SHARE_METHOD_PLACEHOLDER_REFERER}`,
  [SHARE_METHODS.TWITTER]: `https://twitter.com/intent/tweet?via=${SHARE_METHOD_PLACEHOLDER_APP_NAME}net&text=${SHARE_METHOD_PLACEHOLDER_TEXT}&original_referer=${SHARE_METHOD_PLACEHOLDER_REFERER}&url=${SHARE_METHOD_PLACEHOLDER_REFERER}`,
  [SHARE_METHODS.WHATSAPP]: `https://web.whatsapp.com/send?text=${SHARE_METHOD_PLACEHOLDER_REFERER} - ${SHARE_METHOD_PLACEHOLDER_TEXT}`,
  [SHARE_METHODS.EMAIL]: `mailto:?subject=${SHARE_METHOD_PLACEHOLDER_TEXT}&body=${SHARE_METHOD_PLACEHOLDER_REFERER}`,
  [SHARE_METHODS.CHATGPT]: `https://chatgpt.com/?q=${SHARE_METHOD_PLACEHOLDER_AI_PROMPT}`,
  [SHARE_METHODS.PERPLEXITY]: `https://www.perplexity.ai/search/new?q=${SHARE_METHOD_PLACEHOLDER_AI_PROMPT}`
}

export const UTM_MEDIUM_QUERY_PARAM = 'utm_medium'
export const UTM_SOURCE_QUERY_PARAM = 'utm_source'
export const UTM_CAMPAIGN_QUERY_PARAM = 'utm_campaign'
export const UTM_MEDIUM_SOCIAL_MEDIA = 'social-media'
export const UTM_SOURCE_GENERAL = 'general'
export const UTM_CAMPAIGN_SHARE_ADS = 'share_ads'
